/** @jsx jsx */
import { __makeTemplateObject } from "tslib";
import { useRef, useEffect } from 'react';
import { jsx, css } from '@emotion/react';
import { useTheme } from './theme/Providers';
export var getBgColorHelper = function getBgColorHelper(theme, isChecked, disabled, isDarkMode) {
  var _a = theme.colors,
      scales = _a.scales,
      palette = _a.palette;
  if (isDarkMode && disabled) return scales.grayShades[8];
  if (isDarkMode) return scales.grayShades[10];
  if (!isDarkMode && disabled) return scales.grayShades[4];
  if (isChecked) return scales.grayShades[0];
  return palette.gray.fullScale[0];
};
var inputWrapper = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  max-width: 4.75rem;\n  max-height: 2.125rem;\n"], ["\n  position: relative;\n  max-width: 4.75rem;\n  max-height: 2.125rem;\n"])));

var sliderStyles = function sliderStyles(theme, disabled, isChecked, isDarkMode, size) {
  var scales = theme.colors.scales;
  var isSmall = size === 'sm';
  return css({
    display: 'flex',
    cursor: 'pointer',
    pointerEvents: disabled ? 'none' : 'auto',
    width: isSmall ? '3.125rem' : '4rem',
    height: isSmall ? '1.25rem' : '1.75rem',
    borderRadius: '1rem',
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    backgroundColor: disabled ? isDarkMode ? scales.grayShades[9] : scales.grayShades[2] : isDarkMode ? scales.grayShades[4] : scales.grayShades[7],
    position: 'relative',
    transition: 'background-color 0.2s',
    ':before': {
      content: '""',
      position: 'absolute',
      zIndex: 2,
      top: '0.125rem',
      left: '0.125rem',
      width: isSmall ? '1rem' : '1.5rem',
      height: isSmall ? '1rem' : '1.5rem',
      background: getBgColorHelper(theme, isChecked, disabled, isDarkMode),
      borderRadius: '1rem',
      transition: '0.2s'
    },
    ':active:before': {
      width: '2.188rem'
    },
    '> span': {
      fontFamily: theme.fonts.secondary,
      fontSize: isSmall ? '0.75rem' : '1rem',
      lineHeight: isSmall ? '1rem' : '1.5rem',
      color: disabled ? isDarkMode ? scales.grayShades[6] : scales.grayShades[4] : isDarkMode ? scales.grayShades[11] : isChecked ? scales.grayShades[11] : scales.grayShades[0],
      fontWeight: 700,
      textAlign: 'center',
      position: 'relative',
      top: '0.175rem',
      left: isChecked ? '0.5rem' : isSmall ? '1.375rem' : '1.875rem',
      transition: 'opacity 0.2s'
    },
    ':hover': {
      backgroundColor: isDarkMode ? scales.grayShades[3] : scales.grayShades[8]
    },
    ':active': {
      backgroundColor: isDarkMode ? scales.grayShades[2] : scales.grayShades[9]
    }
  });
};

export var Toggle = function Toggle(_a) {
  var ischecked = _a.ischecked,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      _c = _a.labelChecked,
      labelChecked = _c === void 0 ? 'Sí' : _c,
      _d = _a.labelUnChecked,
      labelUnChecked = _d === void 0 ? 'NO' : _d,
      onToggleChange = _a.onToggleChange,
      _e = _a.size,
      size = _e === void 0 ? 'md' : _e;
  var checkbox = useRef(null);
  var theme = useTheme();
  var scales = theme.colors.scales;
  var isDarkMode = theme.colors.mode === 'dark';
  useEffect(function () {
    var input = checkbox.current;
    if (input) input.checked = ischecked; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx("label", {
    css: inputWrapper
  }, jsx("input", {
    type: 'checkbox',
    ref: checkbox,
    onChange: onToggleChange,
    disabled: disabled,
    css: [{
      position: 'absolute',
      left: '-9999px',
      top: '-9999px'
    }, ischecked && {
      '+ span': {
        backgroundColor: disabled ? isDarkMode ? scales.grayShades[9] : scales.grayShades[2] : scales.green[5],
        ':before': {
          left: 'calc(100% - 0.188rem)',
          transform: 'translateX(-100%)'
        },
        ':hover': {
          backgroundColor: scales.green[4]
        },
        ':active': {
          backgroundColor: scales.green[3]
        }
      }
    }]
  }), jsx("span", {
    css: sliderStyles(theme, disabled, ischecked, isDarkMode, size)
  }, jsx("span", null, ischecked ? labelChecked : labelUnChecked)));
};
var templateObject_1;